export const CASH_COUPON = -1; // 代金券
export const COMMON_COUPON = 1; // 点券
export const DIGITAL_HUMAN_BASICS_CARD = 2; // 数字人定制-基础版消耗卡
export const DIGITAL_HUMAN_EXCELLENT_CARD = 3; // 数字人定制-品质版消耗卡
export const DIGITAL_HUMAN_VOICE_BASICS_CARD = 4; // 数字人语音定制-基础版消耗卡
export const DIGITAL_HUMAN_VOICE_EXCELLENT_CARD = 5; // 数字人语音定制-品质版消耗卡
export const FREE = 98; // 免费
export const MONET = 99; // 人民币

export const assetsTypeMapping = {
    [CASH_COUPON]: {value: 'cashCoupon', desc: '代金券'},
    [COMMON_COUPON]: {value: 'commonCoupon', desc: '点券'},
    [DIGITAL_HUMAN_BASICS_CARD]: {value: 'digitalHumanBasicsCard', desc: '数字人形象定制-基础版'},
    [DIGITAL_HUMAN_EXCELLENT_CARD]: {value: 'digitalHumanExcellentCard', desc: '数字人形象定制-品质版'},
    [DIGITAL_HUMAN_VOICE_BASICS_CARD]: {value: 'digitalVoiceBasicsCard', desc: '数字人语音定制-基础版'},
    [DIGITAL_HUMAN_VOICE_EXCELLENT_CARD]: {value: 'digitalVoiceExcellentCard', desc: '数字人语音定制-品质版'},
    [FREE]: 'free',
    [MONET]: 'monet'
};
export const serviceTypeList = [
    {
        value: 'digitalHuman',
        desc: '数字人形象定制次数',
        children: [
            {
                value: 'digitalHumanBasicsCard',
                desc: '基础版'
            },
            {
                value: 'digitalHumanExcellentCard',
                desc: '品质版'
            }
        ]
    },
    {
        value: 'voiceClone',
        desc: '数字人音色定制次数',
        children: [
            {
                value: 'digitalVoiceBasicsCard',
                desc: '基础版'
            },
            {
                value: 'digitalVoiceExcellentCard',
                desc: '品质版'
            }
        ]
    }
];

const generateKeyList = [
    {
        productType: 1,
        values: ['createDigitalHuman']
    },
    {
        productType: 2,
        values: ['createDigitalVoice']
    },
    {
        productType: 3,
        values: ['saveVideoTask'] // 数字人视频生成
    },
    {
        productType: 4, // 文案生成
        values: [
            'textCreateScript', 'textCreateFc', 'textCreateFeed',
            'textCreateScriptRewrite', 'textCreateFcRewrite',
            'textCreateFeedRewrite', 'textCreateTitleV2', 'textCreateScriptV2', 'textCreateScriptV2All'
        ]
    },
    {
        productType: 5, // 图片生成
        values: [] // 0229期不涉及
    },
    {
        productType: 11, // 数字人下载
        values: ['downloadVideo']
    }
];
export const generatePriceMapping = generateKeyList.reduce((mapping, item) => {
    mapping[item.productType] = item.values;
    return mapping;
}, {});

// 点券明细列表，商品id与商品名称的映射
export const GIFT_COUPON = 0; // 赠送优惠券
export const DIGITAL_HUMAN = 10001; // 数字人形象定制
export const DIGITAL_HUMAN_VOICER = 10002; // 数字人音色定制
export const DIGITAL_PERSON_VIDEO = 10003; // 视频合成
export const TEXT_GENERATION = 10004; // 文案生成
export const IMAGE_GENERATION = 10005; // 图片生成
export const COUPON_RECHARGE_ADVANCED = 10006; // 点券充值-高级版
export const COUPON_RECHARGE_INTERMEDIATE = 10007; // 点券充值-中级版
export const COUPON_RECHARGE_BASIC = 10008; // 点券充值-初级版
export const COUPON_RECHARGE_TRIAL = 10009; // 点券充值-体验版
export const COUPON_RECHARGE_EXTEND = 10010; // 点券充值-续航包
export const DIGITAL_HUMAN_DOWNLOAD = 10011; // 数字人视频下载

export const productMap = {
    [GIFT_COUPON]: {
        desc: '赠送点券'
    },
    [DIGITAL_HUMAN]: {
        desc: '数字人形象定制',
        unit: '次'
    },
    [DIGITAL_HUMAN_VOICER]: {
        desc: '数字人音色定制',
        unit: '次'
    },
    [DIGITAL_PERSON_VIDEO]: {
        desc: '视频合成'
    },
    [TEXT_GENERATION]: {
        desc: '文案生成'
    },
    [IMAGE_GENERATION]: {
        desc: '图片生成'
    },
    [COUPON_RECHARGE_ADVANCED]: {
        desc: '点券充值-高级版'
    },
    [COUPON_RECHARGE_INTERMEDIATE]: {
        desc: '点券充值-中级版'
    },
    [COUPON_RECHARGE_BASIC]: {
        desc: '点券充值-初级版'
    },
    [COUPON_RECHARGE_TRIAL]: {
        desc: '点券充值-体验版'
    },
    [COUPON_RECHARGE_EXTEND]: {
        desc: '点券充值-续航包'
    },
    [DIGITAL_HUMAN_DOWNLOAD]: {
        desc: '数字人视频下载'
    }
};
export const contactInfo = {
    innerUC: {
        text: '如您需要下载创意素材或将物料应用至非百度投流用途，请联系您的销售/客服购买相关服务，也可对应咨询至：',
        contactList: [
            {label: '渠道销售', value: 'maying05@baidu.com'},
            {label: '行业销售', value: 'lixue43@baidu.com'},
            {label: '渠道生态', value: 'zhangqinghua02@baidu.com'}
        ]
    },
    outerUC: {
        text: '行业领先的AIGC创意生成服务，1分钟生图，2分钟制作视频，如需体验，欢迎联系我们',
        contactList: [
            {label: '客服电话', value: '400-800-8888'},
            {label: '联系邮箱', value: 'sy-aigc-cy@baidu.com'}
        ]
    }
};
export const couponRules =  [
    {
        order: 'a.',
        // eslint-disable-next-line max-len, vue/max-len
        text: '数字人视频合成：3点券/分钟。单个视频生成时长不超过1min时按1min计费；总生成时长>1min时，若总时长为整分钟，按整分钟收费，剩余不足1min部分，若≥30s，则按1min收费，不足30s按0min计费。'
    },
    {
        order: 'b.',
        text: '口播脚本生成（含口播文案/口播文案优化）：0.05点券/条。'
    }
];
// 点券充值-权益说明
export const couponPayTips  = [
    {
        order: '1.',
        text: '点券用途：点券可用于使用擎舵平台数字人视频合成、AI生图、文案生成等付费服务。'
    },
    {
        order: '2.',
        text: '点券有效期：点券购买后不可退款，有效期3年，请及时使用。'
    },
    {
        order: '3.',
        text: '点券规则',
        children: couponRules
    }
];